import React, { Component } from "react";

class AlertErrorMessage extends Component {
  containerRef = React.createRef();

  componentDidMount() {
    if (this.containerRef.current) {
      this.containerRef.current.parentElement.scrollIntoView(true)
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextProps.timestamp !== this.props.timestamp) {
      if (this.containerRef.current) {
        this.containerRef.current.parentElement.scrollIntoView(true)
      }
    }
  }

  render() {
    return (
      <div
        ref={this.containerRef}
        className={
          "alert alert-danger alert-dismissible fade show " +
          this.props.className
        }
        role="alert"
      >
        {this.props.message}
        <button
          type="button"
          className="close"
          data-dismiss="alert"
          aria-label="Close"
          onClick={() => this.props.onDismiss()}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    );
  }
}

export default AlertErrorMessage;
